/** Width of individual button elements in a detailslist page number control */
export const numberButtonWidth = '1.75em';
/** Styles for individual button elements in a detailslist page number control */
export const numberButtonStyle = {
    root: {
        minWidth: numberButtonWidth,
    },
};
